/** Badge colour and label of each project and task state, shared by every screen that shows them. */
export const PROJECT_STATE_BADGES = {
  completed: { label: "Completado", color: "green" },
  in_progress: { label: "En progreso", color: "yellow" },
  not_started: { label: "No iniciado", color: "blue" },
  cancelled: { label: "Cancelado", color: "red" },
  no_necesario: { label: "No necesario", color: "gray" },
};

export const TASK_STATE_BADGES = {
  planeado: { label: "Planeado", color: "gray" },
  en_desarrollo: { label: "En progreso", color: "purple" },
  finalizado: { label: "Finalizado", color: "green" },
  no_necesario: { label: "No necesario", color: "red" },
};
